import { hasRequiredPermissions, isDisabledForFree, proRequired } from './acl_helper';

const configCards = (keys, configs, permissions, getImg, isSelected, terrainEnabled, layerType) => {
  return keys
    .map(key => {
      const config = configs[key];
      if (!config) {
        return null;
      }
      if (!hasRequiredPermissions(config.aclVisible, permissions)) {
        return null;
      }
      // Some overlays are disabled in 3D
      // Configuration for these is at utils/mapbox/overlay_configs.js
      const disabled = !hasRequiredPermissions(config.aclEnabled, permissions) || (terrainEnabled && config.terrainDisabled);
      const disabledForFree = isDisabledForFree(config.aclEnabled, permissions);
      return {
        key,
        disabled,
        disabledForFree,
        proRequired: proRequired(config.aclEnabled),
        terrainEnabled: config.terrainEnabled,
        hasHeatmap: config.hasHeatmap,
        title: config.displayName,
        keyboardShortcut: config.keyboardShortcut,
        imgSrc: getImg(key.toLowerCase().endsWith('heatmap') ? 'heatmap' : key),
        selected: isSelected(key),
        layerType
      };
    })
    .filter(e => !!e);
};

export { configCards };
